import { __assign } from "tslib";
var UNION_KEY_JOIN = '_';
var KeyUtils = /** @class */ (function () {
    function KeyUtils() {
    }
    KeyUtils.getDBKeyFromKeyPath = function (key) {
        if (typeof key === 'string') {
            return key;
        }
        return key.join(UNION_KEY_JOIN);
    };
    KeyUtils.normalizeUnionKeyValue = function (value) {
        return Array.isArray(value) ? JSON.stringify(value) : value;
    };
    KeyUtils.getKeyFromValue = function (value, keyPath) {
        if (typeof value !== 'object') {
            return value;
        }
        var record = value;
        if (typeof keyPath === 'string') {
            return record[keyPath];
        }
        var keys = [];
        keyPath.forEach(function (key) {
            keys.push(record[key]);
        });
        return keys;
    };
    KeyUtils.addUnionKeyIfNeed = function (value, keyPath) {
        // single primary key , don't need do something
        if (typeof keyPath === 'string') {
            return value;
        }
        var clone = __assign({}, value);
        var unionKey = KeyUtils.getDBKeyFromKeyPath(keyPath);
        var unionKeyValue = [];
        keyPath.forEach(function (key) { return unionKeyValue.push(clone[key]); });
        clone[unionKey] = KeyUtils.normalizeUnionKeyValue(unionKeyValue);
        return clone;
    };
    KeyUtils.deleteUnionKeyIfNeed = function (value, keyPath) {
        // single primary key , don't need do something
        if (typeof keyPath === 'string') {
            return value;
        }
        var clone = __assign({}, value);
        clone[KeyUtils.getDBKeyFromKeyPath(keyPath)] = undefined;
        return clone;
    };
    return KeyUtils;
}());
export { KeyUtils };
//# sourceMappingURL=key-utils.js.map